import { Type } from "class-transformer";
import { DocumentVatTableDTO } from "../../document/dto/document-vat-table.dto";
import { PurchaseDocumentItemDTO } from "./purchase-document-item.dto";
import { PurchaseDocumentDTO } from "./purchase-document.dto";

export class PurchaseUpdateDocumentDTO extends PurchaseDocumentDTO {
	public adjustedDocumentId?: number;
	public adjustedDocumentVersion?: string;
	@Type(() => DocumentVatTableDTO) public vatTable?: DocumentVatTableDTO;
	@Type(() => PurchaseDocumentItemDTO) public items?: PurchaseDocumentItemDTO[] | null;
}
